<template>
  <div class="footer">
      <div class="banxin">
        <p class="bottom">
          <!-- 电话:4008 321 328
          <br> -->
          公司名称：{{footerInfo.companyName}} &nbsp;&nbsp;&nbsp;&nbsp; <br> 联系方式：{{footerInfo.serviceIphone}}
          <br>
          地址：{{footerInfo.companyAddress}}
          <br>
          {{footerInfo.copyRight}}  <a :href="url" target="_blank">{{footerInfo.icp}}</a>
<!--          <br />-->
<!--          <img src="../../assets/images/footerImg.png" style="vertical-align: middle;margin-right: 5px;position: relative;top: -1px;"/>-->
<!--          {{footerInfo.guangdongPublic}}-->
        </p>
      </div>
  </div>
</template>
<script>
import api from "@/api";
import { listSearchMixin } from "@/config/mixin";

export default {
  mixins: [listSearchMixin],
  data () {
    return {
      url:"https://beian.miit.gov.cn/",
      pathList: ['/about','/realize','/collaborate','/contact'],
      footerInfo: {}
    }
  },
  created() {
  	this.getNewCopyRight()
  },
  methods:{
	  goUsDetail(type){
		  this.$router.push({path:this.pathList[+type-1],query:{type}})
	  },
	  //获取底部信息
	  getNewCopyRight(){
		  let params = {
		    url: api.getNewCopyRight,
		    method: 'get',
		    data: {
		    }
		  }
		  this.sendReq(params, (res) => {
			if(res.success){
				this.footerInfo = res.data
			}
		  })
	  }
  }
}
</script>
<style lang = "scss" scoped>
.footer{
    width: 100%;
    /* height: 384px; */
	/* height: 334px; */
    /* height: 434px; */
    padding-bottom: 20px;
    background-color: #000000;
    opacity: 0.82;
    color: #FFFFFF;
    overflow: hidden;
    .banxin{
        width: 1252px;
        height: 100%;
        margin: 0 auto;
        .top{

			margin-top: 50px;            display: flex;
            margin-bottom: 38px;
            text-align: center;
            .leftBox{
                flex: 1;
                display: flex;
                flex-direction: column;
                .title{
                    font-size: 16px;
                    margin-bottom: 33px;
                }
                .number{
                    font-size: 40px;
                    margin-bottom: 12px;
                    font-weight: 500;
                }
                .time{
                    font-size: 18px;
                    margin-bottom: 33px;
                }
                .consult{
                    cursor: pointer;
                    margin: 0 auto;
                    width: 220px;
                    height: 36px;
                    line-height: 36px;
                    border: 1px solid #FFFFFF;
                    box-sizing: border-box;
                    opacity: 0.6;
                }
            }
            .centerBox{
                flex: 1;
                border-left: 2px solid rgba($color: #FFFFFF, $alpha: 0.15);
                border-right: 2px solid rgba($color: #FFFFFF, $alpha: 0.15);
                p{
                    font-size: 16px;
                    line-height: 25px;
                }
                .title{
                    margin-bottom: 33px;
                }
            }
            .rightBox{
                flex: 1;
                display: flex;
                .aboutUs{
                    flex: 1;
                    p{
                        margin-bottom: 20px;
                    }
                    .title{
                        margin-bottom: 33px;
                    }
                }
                .qrCode{
                    flex: 1;
                    .title{
                        margin-bottom: 33px;
                    }
                    img{
                        width: 106px;
                        height: 106px;
                    }
                }
            }
        }
        .bottom{
            text-align: center;
            font-size: 12px;
            line-height: 24px;
            color: white;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/base/footer.vue